import { render, staticRenderFns } from "./QuizHelp.vue?vue&type=template&id=e4611daa"
import script from "./QuizHelp.vue?vue&type=script&lang=js"
export * from "./QuizHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports